import type {
  GetDesignAssets,
  GetDesignAssetsNormalized,
} from '@messenger/types'
import axios from '@/api/axios.config'

export const uploadDesignAsset = async (themeId: string, payload: FormData) => {
  return await axios.post<GetDesignAssets>(
    `createDesignAsset/${themeId}`,
    payload,
    {
      headers: { 'content-type': 'form-data' },
    },
  )
}

export const getDesignAssets = async (themeId: string) => {
  return await axios.get<{ designAssets: GetDesignAssetsNormalized[] }>(
    `designAssets/${themeId}`,
  )
}

export const deleteDesignAsset = async (designAssetId: string) => {
  return await axios.delete(`designAssets/${designAssetId}`)
}
